export enum InputTypeEnum
{
    OneToFiveScale = 0,
    Text = 1,
    DatePicker = 2,
    RadioButton = 3,
    YearSelector = 4
}